import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-select-check-all',
  templateUrl: './select-check-all.component.html',
  styleUrls: ['./select-check-all.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectCheckAllComponent {
  @Input() model: FormControl;
  @Input() values = [];
  @Input() parent: MatSelect;
  text: string;

  isChecked(): boolean {
    return this.model.value && this.values?.length
      && this.model.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.model?.value?.length !== 0 && this.model.value?.length < this.values?.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model.setValue(this.values);
      this.parent?.selectionChange.emit(new MatSelectChange(null, this.values));
    } else {
      this.model.setValue([]);
      this.parent?.selectionChange.emit(new MatSelectChange(null, []));
    }
  }
}
